import { CostCenter } from '../entities/costCenter';
import { Injectable, Injector } from '@angular/core';
import { PayStub } from '../entities/pay-stub';
import { Subject, Observable} from 'rxjs';
import { tap, map,retry } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams,HttpErrorResponse } from '@angular/common/http';
import { BaseService } from '../../shared/_utils/services/base-service';
import * as FileSaver from 'file-saver';
import { catchError } from 'rxjs/operators';

@Injectable()
export class DataExtractionService extends BaseService {

   uri =  '/api/dataExtraction/';

  constructor(injector: Injector, private http: HttpClient) { super(injector); }

  downloadData(url:string ,object: any ): Observable<any> {
    let ruta = this.rutaServidor + this.uri   +  url;
    //console.log("ruta en el servicio: "  + ruta);  + object
    this.spinnerService.showAll();  
    return this.httpClient.post(ruta, object)
        .pipe( 
            /*catchError((err, caught) => { 
                console.log("catchError : "  + err);
                this.spinnerService.hideAll(); 
                this.notificationService.serverErrorMessage(err.status +' - Ocurrió un error. Por favor, intentelo nuevamente más tarde. ');
                return new Observable<Blob>();
            }) ,*/
            //retry(3),
            catchError((e)=>{  
               //this.spinnerService.hideAll(); 
               // this.notificationService.serverErrorMessage(e.status +' - Ocurrió un error. Por favor, intentelo nuevamente más tarde. ');
               // return new Observable<Blob>();
               //this.notificationService.smallBoxError(e); 
               //return new Observable<Blob>();
               //console.log(e);
               this.spinnerService.hideAll();
                return Observable.throw(e.status +' - Ocurrió un error. Por favor, intentelo nuevamente más tarde. ');
                 
              }),
            map(res =>  {   
                //console.log(res);
                //this.spinnerService.hideAll();
                //let bean = new Blob([res],{ type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                //FileSaver.saveAs(bean, nameFile);
                return res;
                ///return bean;*/
            }) 
        ); 

    }

    verifyCreationFinished(nameFile : string):Observable<Blob>{
        let ruta = this.rutaServidor + this.uri   +  'verifyCreationFinished'; 
        //this.spinnerService.showAll();  
        return this.httpClient.post(ruta, nameFile, {responseType: 'blob' })
            .pipe( 
                /*catchError((err, caught) => { 
                    console.log("catchError : "  + err);
                    this.spinnerService.hideAll(); 
                    this.notificationService.serverErrorMessage(err.status +' - Ocurrió un error. Por favor, intentelo nuevamente más tarde. ');
                    return new Observable<Blob>();
                }) ,*/
                //retry(3),
                catchError((e)=>{  
                    //console.log(e);
                    //this.spinnerService.hideAll(); 
                   // this.notificationService.serverErrorMessage(e.status +' - Ocurrió un error. Por favor, intentelo nuevamente más tarde. ');
                   // return new Observable<Blob>();
                   //this.notificationService.smallBoxError(e); 
                   //return new Observable<Blob>();
                    return Observable.throw(e.status +' - Ocurrió un error. Por favor, intentelo nuevamente más tarde. ');
                     
                  }),
                map(res =>  {  
                        //console.log(res);
                        this.spinnerService.hideAll();
                        let bean = new Blob([res],{ type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                        FileSaver.saveAs(bean, nameFile);
                        return bean;
                      
                }) 
            ); 
    
        }
    
}



// WEBPACK FOOTER //
// ./src/app/core/services/data-extraction.service.ts